module.exports = __webpack_public_path__ + "img/sole.e947c34.svg";